import { useEffect } from 'react';
import { BLUR_COMMAND, COMMAND_PRIORITY_LOW, LexicalEditor } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

const OnBlurPlugin = ({
  onBlur,
}: {
  onBlur?: (event: FocusEvent, editor: LexicalEditor) => void;
}) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const unregisterListener = editor.registerCommand(
      BLUR_COMMAND,
      (payload: FocusEvent) => {
        onBlur?.(payload, editor);
        return false;
      },
      COMMAND_PRIORITY_LOW,
    );

    return () => {
      unregisterListener();
    };
  }, [editor]);

  return null;
};

OnBlurPlugin.defaultProps = {
  onBlur: undefined,
};

export default OnBlurPlugin;
